import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getFiltredProjectsRequest: ['response'],
    getFiltredProjectsSuccess: ['response', 'loading'],
    getFiltredProjectsFailure: ['error'],
})

export const getFiltredProjectsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getFiltredProjectsSuccess = (state, { response }) => {
    return state.merge({
        error: false,
        response,
        loading: false,
    })
}
const getFiltredProjectsFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getFiltredProjectsRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_FILTRED_PROJECTS_REQUEST]: getFiltredProjectsRequest,
    [Types.GET_FILTRED_PROJECTS_SUCCESS]: getFiltredProjectsSuccess,
    [Types.GET_FILTRED_PROJECTS_FAILURE]: getFiltredProjectsFailure,
})
